
export default function legendColorsBySector(sectors) {
    let colorObj = {}
    let i= 0
    for (let sector in sectors) {
        colorObj[sectors[sector]] = this.catColors[i]
        i++;
    }
    return colorObj
}